import React from 'react'

const ViewRate = () => {
  return (
    <div>ViewRate</div>
  )
}

export default ViewRate